import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import EditorRoute from './components/EditorRoute';
import StudentRoute from './components/StudentRoute';
import ThemesRoute from './components/ThemesRoute';
import AdminRoute from './components/AdminRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import TaskListPage from './pages/TaskListPage';
import TaskDetailPage from './pages/TaskDetailPage';
import TaskEditorPage from './pages/TaskEditorPage';
import BulkImportPage from './pages/BulkImportPage';
import CollaborativePage from './pages/CollaborativePage';
import WorkPage from './pages/WorkPage';
import MyTasksPage from './pages/MyTasksPage';
import MyAttemptsPage from './pages/MyAttemptsPage';
import MyLessonsPage from './pages/MyLessonsPage';
import TeacherDashboardPage from './pages/TeacherDashboardPage';
import TeacherStudentWorkPage from './pages/TeacherStudentWorkPage';
import TeacherStudentQuestionnairePage from './pages/TeacherStudentQuestionnairePage';
import TeacherStudentActivityPage from './pages/TeacherStudentActivityPage';
import TeacherListCreatePage from './pages/TeacherListCreatePage';
import DashboardOrRedirect from './components/DashboardOrRedirect';
import ProfilePage from './pages/ProfilePage';
import QuestionnairePage from './pages/QuestionnairePage';
import InvitePage from './pages/InvitePage';
import MyTeachersPage from './pages/MyTeachersPage';
import StudentTopicProgressPage from './pages/StudentTopicProgressPage';
import TaskCatalogPage from './pages/TaskCatalogPage';
import TaskCatalogPrintPage from './pages/TaskCatalogPrintPage';
import EditorSettingsPage from './pages/EditorSettingsPage';
import TeacherTagsPage from './pages/TeacherTagsPage';
import TopicProgramPage from './pages/TopicProgramPage';
import AdminTopicProgramsPage from './pages/AdminTopicProgramsPage';
import KonspektyListPage from './pages/KonspektyListPage';
import KonspektDetailPage from './pages/KonspektDetailPage';
import KonspektFormPage from './pages/KonspektFormPage';
import PracticeQuizzesPage from './pages/PracticeQuizzesPage';
import BillingPage from './pages/BillingPage';
import BillingReturnPage from './pages/BillingReturnPage';
import TeacherBillingPage from './pages/TeacherBillingPage';
import TeacherStudentBillingPage from './pages/TeacherStudentBillingPage';
import ParentHomePage from './pages/ParentHomePage';
import ParentStudentActivityPage from './pages/ParentStudentActivityPage';
import PrivacyPage from './pages/PrivacyPage';
import ConsentPage from './pages/ConsentPage';
import OfertaPage from './pages/OfertaPage';
import './App.css';

/** Data Router: нужен для useBlocker на странице работы с задачей (WorkPage). */
const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <PrivateRoute><DashboardOrRedirect /></PrivateRoute> },
      { path: 'login', element: <LoginPage /> },
      { path: 'register', element: <RegisterPage /> },
      { path: 'privacy', element: <PrivacyPage /> },
      { path: 'consent', element: <ConsentPage /> },
      { path: 'oferta', element: <OfertaPage /> },
      { path: 'profile', element: <PrivateRoute><ProfilePage /></PrivateRoute> },
      { path: 'questionnaire', element: <PrivateRoute><QuestionnairePage /></PrivateRoute> },
      { path: 'billing/return', element: <PrivateRoute><BillingReturnPage /></PrivateRoute> },
      { path: 'billing', element: <PrivateRoute><BillingPage /></PrivateRoute> },
      { path: 'parent/children/:studentId/topic-progress', element: <PrivateRoute><StudentTopicProgressPage /></PrivateRoute> },
      { path: 'parent/children/:studentId/activity', element: <PrivateRoute><ParentStudentActivityPage /></PrivateRoute> },
      { path: 'parent', element: <PrivateRoute><ParentHomePage /></PrivateRoute> },
      { path: 'settings/editor', element: <PrivateRoute><EditorSettingsPage /></PrivateRoute> },
      { path: 'invite/:token', element: <InvitePage /> },
      { path: 'tasks', element: <PrivateRoute><StudentRoute><TaskListPage /></StudentRoute></PrivateRoute> },
      { path: 'themes/:slug', element: <ThemesRoute><TopicProgramPage /></ThemesRoute> },
      { path: 'admin/topic-programs', element: <AdminRoute><AdminTopicProgramsPage /></AdminRoute> },
      { path: 'catalog/print/:tagSlug', element: <PrivateRoute><TaskCatalogPrintPage /></PrivateRoute> },
      { path: 'catalog', element: <PrivateRoute><TaskCatalogPage /></PrivateRoute> },
      { path: 'practice-quizzes', element: <PrivateRoute><PracticeQuizzesPage /></PrivateRoute> },
      { path: 'tasks/:slug', element: <PrivateRoute><TaskDetailPage /></PrivateRoute> },
      { path: 'work/:taskSlug', element: <PrivateRoute><WorkPage /></PrivateRoute> },
      { path: 'sessions/:lessonSessionId/tasks/:taskSlug', element: <PrivateRoute><WorkPage /></PrivateRoute> },
      { path: 'my-tasks', element: <PrivateRoute><MyTasksPage /></PrivateRoute> },
      { path: 'my-attempts', element: <PrivateRoute><MyAttemptsPage /></PrivateRoute> },
      { path: 'my-lessons', element: <PrivateRoute><StudentRoute><MyLessonsPage /></StudentRoute></PrivateRoute> },
      { path: 'konspekty/new', element: <PrivateRoute><KonspektFormPage /></PrivateRoute> },
      { path: 'konspekty/:slug/edit', element: <PrivateRoute><KonspektFormPage /></PrivateRoute> },
      { path: 'konspekty/:slug', element: <PrivateRoute><KonspektDetailPage /></PrivateRoute> },
      { path: 'konspekty', element: <PrivateRoute><KonspektyListPage /></PrivateRoute> },
      { path: 'my-teachers', element: <PrivateRoute><MyTeachersPage /></PrivateRoute> },
      { path: 'topic-progress', element: <PrivateRoute><StudentTopicProgressPage /></PrivateRoute> },
      { path: 'dashboard', element: <PrivateRoute><DashboardOrRedirect /></PrivateRoute> },
      { path: 'teacher', element: <EditorRoute><TeacherDashboardPage /></EditorRoute> },
      { path: 'teacher/billing/:studentId', element: <EditorRoute><TeacherStudentBillingPage /></EditorRoute> },
      { path: 'teacher/billing', element: <EditorRoute><TeacherBillingPage /></EditorRoute> },
      { path: 'teacher/students/:studentId', element: <EditorRoute><TeacherStudentWorkPage /></EditorRoute> },
      { path: 'teacher/students/:studentId/questionnaire', element: <EditorRoute><TeacherStudentQuestionnairePage /></EditorRoute> },
      { path: 'teacher/students/:studentId/activity', element: <EditorRoute><TeacherStudentActivityPage /></EditorRoute> },
      { path: 'teacher/students/:studentId/topic-progress', element: <EditorRoute><StudentTopicProgressPage /></EditorRoute> },
      { path: 'teacher/lists/create', element: <EditorRoute><TeacherListCreatePage /></EditorRoute> },
      { path: 'teacher/tasks', element: <EditorRoute><TaskEditorPage /></EditorRoute> },
      { path: 'teacher/tasks/import', element: <EditorRoute><BulkImportPage /></EditorRoute> },
      { path: 'teacher/tags', element: <EditorRoute><TeacherTagsPage /></EditorRoute> },
      { path: 'collaborative', element: <CollaborativePage /> },
      { path: 'collaborative/:sessionId', element: <CollaborativePage /> },
    ],
  },
]);

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ThemeProvider>
  );
}
